jQuery($ => {
    class MeganavMenu {
      constructor(element) {
        this._            = element;
        this._element     = $(element);
        this._panels      = this._element.find('.m-meganav-panel');
        this._tabs        = this._element.find('.a-meganav-panel-tab');
        this._tabInputs   = this._element.find('.a-meganav-panel-tab__input');
        this._backButtons = this._element.find('.m-meganav-panel__back-button');
        
        this._shouldAutoSelectFirstItem = this._element.data('auto-select-first-item');

        this._isMobile = window.innerWidth < 1025;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        if (window.innerWidth < 1025) {
          this._shouldAutoSelectFirstItem = false;
        }

        if (this._shouldAutoSelectFirstItem) {
          // Trigger show panel on the first panel so it auto-displays its children
          this.showPanel($(this._panels[0]));
        }

        this.setupHandlers();

        this._element.trigger( 'init', this );
      }

      hidePanel(panel) {
        panel.addClass('m-meganav-panel--hidden');
        panel.attr('inert', '');

        // Deselect its radio button
        const input = $(`input[value="${panel.attr('id')}"]`);
        if (input) {
          input.prop('checked', false);
        }
      }

      showPanel(panel) {
        panel.removeClass('m-meganav-panel--hidden');
        panel.removeAttr('inert');

        // Check what level is the panel in
        let panelLevel = 1;
        if (panel.hasClass('m-meganav-menu__panel--level-2')) {
          panelLevel = 2;
        } else if (panel.hasClass('m-meganav-menu__panel--level-3')) {
          panelLevel = 3;
        }

        // If panel is level 1, hide all other panels
        if (panelLevel === 1) {
          this._panels.each((index, element) => {
            if (element !== panel[0]) {
              this.hidePanel($(element));
            }
          });
        } else if (panelLevel === 2) {
          // If panel is level 2, hide all level 3 panels
          this._panels.each((index, element) => {
            if ($(element).hasClass('m-meganav-menu__panel--level-3')) {
              this.hidePanel($(element));
            }
          });
        }

        if (this._shouldAutoSelectFirstItem && (panelLevel === 1 || panelLevel === 2)) {
          // Look for tabs inside the panel
          // If there are tabs, show the first tab
          const tabs = panel.find('.a-meganav-panel-tab');
          if (tabs.length > 0) {
            const firstTab = $(tabs[0]);
            firstTab.find('.a-meganav-panel-tab__input').prop('checked', true);
            this.showPanel($(`#${firstTab.find('.a-meganav-panel-tab__input').val()}`));
            
          }
        } else if (!this._shouldAutoSelectFirstItem) {
          // Deselect all tabs
          const tabs = panel.find('.a-meganav-panel-tab');
          tabs.each((index, element) => {
            $(element).find('.a-meganav-panel-tab__input').prop('checked', false);
          });
        }

        // Does this._element have any m-meganav-menu__panel--level-2 without m-meganav-panel--hidden class?
        const level2Panels = this._element.find('.m-meganav-menu__panel--level-2:not(.m-meganav-panel--hidden)');
        this._element.toggleClass('m-meganav-menu--has-level-2', level2Panels.length > 0);
        const level3Panels = this._element.find('.m-meganav-menu__panel--level-3:not(.m-meganav-panel--hidden)');
        this._element.toggleClass('m-meganav-menu--has-level-3', level3Panels.length > 0);
      }

      handleTabChange(event) {
        const target = $(event.target);
        const radioGroupName = target.attr('name');

        // Close other panels of the same level
        $(`input[name="${radioGroupName}"]`).each((index, element) => {
          // Panel ID is the value of the radio button
          const panelId = $(element).val();
          const panel = $(`#${panelId}`);

          if (panel) {            
            if ($(element).is(':checked')) {
              this.showPanel(panel);              
            } else {
              this.hidePanel(panel);
            }
          }
        })
      }

      handleBackButtonClick(event) {
        // Get ID of parent of button
        const target = $(event.currentTarget);
        const parentPanelId = target.parent().attr('id');
        if (parentPanelId) {
          // If parent panel is root level, ignore
          if (target.parent().hasClass('m-meganav-menu__root-panel')) {
            return;
          }

          const parentPanel = $(`#${parentPanelId}`);
          if (parentPanel) {
            this.hidePanel(parentPanel);
          }
        }
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._tabInputs.on('change', (e) => this.handleTabChange(e));
        this._backButtons.on('click', (e) => this.handleBackButtonClick(e));

        $(window).on('resize', () => {
          if (window.innerWidth < 1025) {
            if (this._shouldAutoSelectFirstItem) {
              this._shouldAutoSelectFirstItem = false;              
            }

            // Wasnt mobile before resize
            if (!this._isMobile) {
              this._isMobile = true;
              // If it went from desktop to mobile, hide all panels except the first one
              this._panels.each((index, element) => {
                if (index > 0) {
                  this.hidePanel($(element));
                }
              });
            }
          } else {
            this._shouldAutoSelectFirstItem = this._element.data('auto-select-first-item');
            if (this._isMobile) {
              this._isMobile = false;
              // If it went from mobile to desktop, show the first panel
              // (it will auto-display its children)
              this.showPanel($(this._panels[0]));
            }
          }
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.meganav_menu = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].meganav_menu = new MeganavMenu(_[i], opt);
        else
          ret = _[i].meganav_menu[opt].apply(_[i].meganav_menu, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-meganav-menu').meganav_menu();
});